import { useTranslation } from "../contexts/LocaleContext";

export function ConversationalCommerce() {
  const { t } = useTranslation();
  return (
    <div className="md:w-1/2 flex justify-center w-full">
      <div className="relative w-full h-90 md:h-96 shadow-2xl rounded-2xl overflow-hidden border border-slate-200/60 bg-white/90 backdrop-blur-xl">
        <div className="transition-all duration-1000 transform opacity-100 translate-y-0 w-full h-full p-6">
          <div className="flex items-center justify-between mb-6 border-b border-slate-100 pb-4">
            <div className="flex gap-2">
              <div className="w-3 h-3 rounded-full bg-red-400" />
              <div className="w-3 h-3 rounded-full bg-yellow-400" />
              <div className="w-3 h-3 rounded-full bg-green-400" />
            </div>
            <div className="bg-slate-50 px-4 py-1.5 rounded-md text-xs font-mono text-slate-400 flex items-center gap-2 border border-slate-100">
              <span className="w-2 h-2 rounded-full bg-green-500" />
              https://dashboard.hsmail.com
            </div>
            <div className="w-16" />
          </div>
          <div className="flex gap-6 h-full">
            <div className="hidden md:flex flex-col gap-3 w-30 border-r border-slate-100 pr-4">
              <div className="h-8 w-24 bg-blue-100 rounded mb-4" />
              <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-slate-50">
                <div className="w-4 h-4 rounded bg-blue-500" />
                <div className="h-2 rounded w-20 bg-blue-200" />
              </div>
              <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-slate-50">
                <div className="w-4 h-4 rounded bg-slate-200" />
                <div className="h-2 rounded w-16 bg-slate-100" />
              </div>
              <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-slate-50">
                <div className="w-4 h-4 rounded bg-slate-200" />
                <div className="h-2 rounded w-16 bg-slate-100" />
              </div>
              <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-slate-50">
                <div className="w-4 h-4 rounded bg-slate-200" />
                <div className="h-2 rounded w-16 bg-slate-100" />
              </div>
            </div>
            <div className="flex-1">
              <div className="flex justify-between items-end mb-6 flex-wrap">
                <div className="flex-1">
                  <div className="text-xs text-slate-400 font-semibold uppercase tracking-wider mb-1">
                    {t("commerce.sent_volume")}
                  </div>
                  <div className="text-3xl font-bold text-slate-800">
                    1,245,300
                  </div>
                </div>
                <div className="flex flex-1 gap-1">
                  <div className="p-1 w-[50px] h-[50px] flex justify-center items-center bg-blue-50 text-blue-600 text-xs font-bold rounded-full">
                    +12.5%
                  </div>
                  <div className="py-1 px-3 flex items-center justify-center bg-slate-100 text-slate-500 text-xs font-bold rounded-full">
                    {t("commerce.last_30_days")}
                  </div>
                </div>
              </div>
              <div className="relative h-32 w-full flex items-end justify-between gap-1 mb-6">
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "42%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "58%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "45%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "68%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "52%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "75%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "60%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "85%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "72%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "90%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "65%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "88%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "55%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "78%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "62%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "92%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "70%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "85%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "58%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "80%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "48%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "72%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "65%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "88%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "55%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "75%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "60%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "95%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "70%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "85%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "50%" }}
                  />
                </div>
                <div className="w-full h-full bg-blue-50 rounded-t-sm relative group overflow-hidden">
                  <div
                    className="absolute bottom-0 w-full bg-blue-500 transition-all duration-1000 ease-out"
                    style={{ height: "90%" }}
                  />
                </div>
              </div>
              <div className="space-y-3">
                <div className="flex justify-between text-xs text-slate-400 font-medium border-b border-slate-100 pb-2">
                  <span>{t("commerce.template")}</span>
                  <span>{t("commerce.status")}</span>
                  <span>{t("commerce.open_rate")}</span>
                </div>
                <div className="flex justify-between items-center text-sm">
                  <div className="font-mono text-slate-600">
                    {t("commerce.success_email")}
                  </div>
                  <div className="px-2 py-0.5 rounded-full text-xs font-bold bg-green-50 text-green-600">
                    {t("commerce.sent")}
                  </div>
                  <div className="font-bold text-slate-800">25.8%</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConversationalCommerce;
